export class MailFiltersDb{
  public static list = [
    {
      'id': 0,
      'handle': 'starred',
      'title': 'Starred',
      'icon': 'star-o'
    },
    {
      'id': 1,
      'handle': 'important',
      'title': 'Important',
      'icon': 'tag-o'
    }
  ];
}
